module.exports = __webpack_public_path__ + "images/349964982197f62b63ae08f8be9b35c3.png";